export const Card_Flip = `
<h3>Four Flip-Card Template</h3>
<hr />
<article id="card-flip4">
  <div class="row d-flex justify-content-center intro">
    Below, you’ll see how some people might approach this project to ensure confidence in the end result. However, these strategies may have the opposite effect on you. Flip the cards to turn what is drains your confidence into a confidence builder
  </div>

  <div class="row">
    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-xl-center justify-content-lg-end justify-content-md-end justify-content-center">
      <div id="card-flip41" class="card-flip" onclick="cardFlip(41)">
        <div id="top-curve41" class="swipe top" style="display: none">
          <div id="top-curve-color41" class="stripe top" style="background-color: #5D40B0;"></div>
          <div id="caret-up41" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content41" class="content">
          <div id="card-front41" class="card-front">
            Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block41" class="color-block" style="background-color: #5D40B0;">
          </div>
          <div id="card-back41" class="card-back">
            Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end41"></div>
        </div>
        <div id="bottom-curve41" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #5D40B0;">
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-xl-center justify-content-lg-start justify-content-md-start justify-content-center">
      <div id="card-flip42" class="card-flip" onclick="cardFlip(42)">
        <div id="top-curve42" class="swipe top" style="display: none">
          <div id="top-curve-color42" class="stripe top" style="background-color: #01b8c3;"></div>
          <div id="caret-up42" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content42" class="content">
          <div id="card-front42" class="card-front">
            <img src="https://pdpdevelopment.blob.core.windows.net/roadrunner-cdn/courses/images/RalphWaiving.gif" style="width: 215px" />
          </div>
          <div id="color-block42" class="color-block" style="background-color: #01b8c3;">
          </div>
          <div id="card-back42" class="card-back">
            Me fail English? That's unpossible.
            <br /><br />
            It says "choo-choo-choose me" and there's a picture of a train.
            <br /><br />
            When I grow up, I want to be a principal, or a caterpillar!
          </div>
          <div id="end42"></div>
        </div>
        <div id="bottom-curve42" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #01b8c3;">
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix visible-sm"></div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-xl-center justify-content-lg-end justify-content-md-end justify-content-center">
      <div id="card-flip43" class="card-flip" onclick="cardFlip(43)">
        <div id="top-curve43" class="swipe top" style="display: none">
          <div id="top-curve-color43" class="stripe top" style="background-color: #FABB2A;"></div>
          <div id="caret-up43" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content43" class="content">
          <div id="card-front43" class="card-front">
            Only a few words on the front
          </div>
          <div id="color-block43" class="color-block" style="background-color: #FABB2A;">
          </div>
          <div id="card-back43" class="card-back">
            Only a few words on the back
          </div>
          <div id="end43"></div>
        </div>
        <div id="bottom-curve43" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #FABB2A;">
          </div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12 d-flex justify-content-xl-center justify-content-lg-start justify-content-md-start justify-content-center">
      <div id="card-flip44" class="card-flip" onclick="cardFlip(44)">
        <div id="top-curve44" class="swipe top" style="display: none">
          <div id="top-curve-color44" class="stripe top" style="background-color: #5D40B0;"></div>
          <div id="caret-up44" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content44" class="content">
          <div id="card-front44" class="card-front">
            A lot of words on the front: Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block44" class="color-block" style="background-color: #5D40B0;">
          </div>
          <div id="card-back44" class="card-back">
            A lot of words on the back: Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization. Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end44"></div>
        </div>
        <div id="bottom-curve44" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #5D40B0;">
          </div>
        </div>
      </div>
    </div>
  </div>
</article>

<h3>Three Flip-Card Template</h3>
<hr />
<article id="card-flip3">
  <div class="row d-flex justify-content-center intro">
    Below, you’ll see how some people might approach this project to ensure confidence in the end result. However, these strategies may have the opposite effect on you. Flip the cards to turn what is drains your confidence into a confidence builder
  </div>

  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-lg-center justify-content-md-end justify-content-center">
      <div id="card-flip31" class="card-flip" onclick="cardFlip(31)">
        <div id="top-curve31" class="swipe top" style="display: none">
          <div id="top-curve-color31" class="stripe top" style="background-color: #5D40B0;"></div>
          <div id="caret-up31" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content31" class="content">
          <div id="card-front31" class="card-front">
            Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block31" class="color-block" style="background-color: #5D40B0;">
          </div>
          <div id="card-back31" class="card-back">
            Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end31"></div>
        </div>
        <div id="bottom-curve31" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #5D40B0;">
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-lg-center justify-content-md-start justify-content-center">
      <div id="card-flip32" class="card-flip" onclick="cardFlip(32)">
        <div id="top-curve32" class="swipe top" style="display: none">
          <div id="top-curve-color32" class="stripe top" style="background-color: #01b8c3;"></div>
          <div id="caret-up32" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content32" class="content">
          <div id="card-front32" class="card-front">
            Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block32" class="color-block" style="background-color: #01b8c3;">
          </div>
          <div id="card-back32" class="card-back">
            Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end32"></div>
        </div>
        <div id="bottom-curve32" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #01b8c3;">
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-center">
      <div id="card-flip33" class="card-flip" onclick="cardFlip(33)">
        <div id="top-curve33" class="swipe top" style="display: none">
          <div id="top-curve-color33" class="stripe top" style="background-color: #FABB2A;"></div>
          <div id="caret-up33" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content33" class="content">
          <div id="card-front33" class="card-front">
            Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block33" class="color-block" style="background-color: #FABB2A;">
          </div>
          <div id="card-back33" class="card-back">
            Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end33"></div>
        </div>
        <div id="bottom-curve33" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #FABB2A;">
          </div>
        </div>
      </div>
    </div>
  </div>
</article>

<h3>Two Flip-Card Template</h3>
<hr />
<article id="card-flip2">
  <div class="row d-flex justify-content-center intro">
    Below, you’ll see how some people might approach this project to ensure confidence in the end result. However, these strategies may have the opposite effect on you. Flip the cards to turn what is drains your confidence into a confidence builder
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-12 d-flex justify-content-center">
      <div id="card-flip21" class="card-flip" onclick="cardFlip(21)">
        <div id="top-curve21" class="swipe top" style="display: none">
          <div id="top-curve-color21" class="stripe top" style="background-color: #5D40B0;"></div>
          <div id="caret-up21" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content21" class="content">
          <div id="card-front21" class="card-front">
            Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block21" class="color-block" style="background-color: #5D40B0;">
          </div>
          <div id="card-back21" class="card-back">
            Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end21"></div>
        </div>
        <div id="bottom-curve21" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #5D40B0;">
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-12 d-flex justify-content-center">
      <div id="card-flip22" class="card-flip" onclick="cardFlip(22)">
        <div id="top-curve22" class="swipe top" style="display: none">
          <div id="top-curve-color22" class="stripe top" style="background-color: #01b8c3;"></div>
          <div id="caret-up22" class="caretImg up" style="display: none"><img src="assets/images/icons/ICONS_Dropdown_CaretUp.svg" /></div>
        </div>
        <div id="content22" class="content">
          <div id="card-front22" class="card-front">
            Immediately go talk to as many people as possible, sharing and vetting ideas and clarifying thoughts out loud.
          </div>
          <div id="color-block22" class="color-block" style="background-color: #01b8c3;">
          </div>
          <div id="card-back22" class="card-back">
            Want answers to questions like “What’s the bigger picture?” to feel confident that what you’re doing connects to the purpose of the organization.you’re doing connects to the purpose of the organization.
          </div>
          <div id="end22"></div>
        </div>
        <div id="bottom-curve22" class="swipe bottom">
          <div class="filler bottom">
            <div class="caretImg down"><img src="assets/images/icons/ICONS_Dropdown.svg" /></div>
          </div>
          <div class="stripe bottom" style="background-color: #01b8c3;">
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
`;
